import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_SAP_PHONE_COLLECTION = createFcmDetails('starter_sap_phone_collection', {
	owner: 'Starter Activation',
	context: 'Start A Petition Page',
	description: `This controls the validation rule for the phone_collection step in the SAP flow.
		The value will determine whether the step is:
		- "off" - The step will not be shown.
		- "optional" - The step will be shown, but not require a valid phone number to proceed.
		- "mandatory" - The step will be shown and require a valid phone number to proceed.`,
	import: false,
});
